package kotlinReactComponents

import constants.RuleSetClass
import kotlinx.html.js.onMouseDownFunction
import kotlinx.html.js.onMouseOutFunction
import kotlinx.html.js.onMouseOverFunction
import org.w3c.dom.HTMLElement
import react.Props
import react.dom.attrs
import react.fc
import react.useState
import styled.css
import styled.styledDiv


external interface NavigationElementProps : Props {
    var title: String
    var onClickedEntryNavigationChange : (String) -> Unit
    var titleStyle: RuleSetClass
}



//fun RBuilder.navigationElement(title: String, clickedEntry: KMutableProperty0<String>, titleStyle: RuleSet) {
    val navigationElement = fc<NavigationElementProps>("NavigationElement") { props->
    var mouseIsOver: String by useState("")
    styledDiv {
        css {
            +DropdownMenuStyles.dropdown
            +props.titleStyle.style
            if (mouseIsOver == props.title) {
                +DropdownMenuStyles.boldText
            } else {
                +DropdownMenuStyles.normalText
            }
        }
        this.attrs {
            text(props.title)
            onMouseDownFunction = { event ->
                props.onClickedEntryNavigationChange((event.target as HTMLElement).innerText)
            }
            onMouseOverFunction = { event ->
                mouseIsOver = (event.target as HTMLElement).innerText
            }
            onMouseOutFunction = {
                mouseIsOver = ""
            }
        }
    }
}



